/* @ngInject */

export default () => (input, query) => {
  let out = [];
  if (!query || query === '' || query === 'ALL') {
    out = input;
  } else {
    const groups = _.groupBy(input, (i) => {
      if (i.docType === 'product') {
        return i.getLenderName().charAt(0).toUpperCase();
      }
      return i.getName().charAt(0).toUpperCase();
    });
    out = groups[query];
  }
  return out;
};
